import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import MembershipModal from './components/MembershipModal';
import AppRoutes from './routes/AppRoutes';
import useSession from './hooks/useSession';
import { requestAccess } from './firebase/admin';

function App() {
  const { loading, user, isAdmin, hasMember } = useSession();
  const [showPending, setShowPending] = useState(false);

  // When a signed-in but not-yet-approved user lands, register a signup request
  // (which emails the admins). Idempotent server-side; once per session here.
  useEffect(() => {
    if (!user || isAdmin) return;
    const key = `access-requested:${user.uid}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    requestAccess().catch(() => {});
  }, [user, isAdmin]);

  // A signed-in visitor who isn't a member yet (fresh sign-up, or a sign-in
  // while their request is pending) gets a one-time "we're reviewing" modal.
  // Deduped per user per session so reloads don't nag; a new sign-in shows it
  // again.
  useEffect(() => {
    if (loading || !user || isAdmin || hasMember) {
      setShowPending(false);
      return;
    }
    try {
      if (sessionStorage.getItem(`membership-pending-seen:${user.uid}`)) return;
    } catch (_) {
      /* storage disabled — just show it */
    }
    setShowPending(true);
  }, [loading, user, isAdmin, hasMember]);

  const dismissPending = () => {
    try {
      if (user) sessionStorage.setItem(`membership-pending-seen:${user.uid}`, '1');
    } catch (_) {
      /* no-op */
    }
    setShowPending(false);
  };

  return (
    <div className="App">
      <div className="bg-decor" aria-hidden="true">
        <span className="b1" />
        <span className="b2" />
        <span className="b3" />
      </div>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      {showPending && <MembershipModal onClose={dismissPending} />}
    </div>
  );
}

export default App;
